import sortByPropText from './content/manageSets/sortByPropText'

/**
 * Sorts an array of objects by the text in multiple props
 * @param {array} array Objects to be sorted 
 * @param {array} propsArray Array of property names (strings) to sort by alphabetically, first is highest priority
 * @returns {array} Sorted array of objects.
 */
export default function sortByProps(array, propsArray) {
  //invert props array
  const propsToSort = propsArray.slice(0)
  propsToSort.reverse()
  let sortedArray = array.slice(0)
  propsToSort.forEach((prop) => {
    sortedArray = sortByPropText(sortedArray, prop)
  })
  return sortedArray
}


// WEBPACK FOOTER //
// ./src/helpers/sortByProps.js